import { useMessageSource } from "react-message-source";
import * as Yup from "yup";

export default function usePasswordResetNewPasswordFormValidationSchema() {
  const { getMessage } = useMessageSource();

  const minPasswordLength = 12;
  const validatePassword = Yup.string()
    .min(
      minPasswordLength,
      getMessage("Validation.message-minLengthCharacters", minPasswordLength),
    )
    .matches(/\d/, getMessage("Validation.message-mustContainDigits"))
    .matches(
      /[a-z]/,
      getMessage("Validation.message-mustContainLowerCaseLetter"),
    )
    .matches(
      /[A-Z]/,
      getMessage("Validation.message-mustContainUpperCaseLetter"),
    )
    .matches(
      /[^A-Za-z0-9]/,
      getMessage("Validation.message-mustContainSpecialChar"),
    )
    .required(getMessage("Validation.message-required"));

  return Yup.object().shape({
    newPassword: validatePassword,
  });
}
